import {useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAccount} from './useAccount'

export const useRedirectOnAccountSwitch = (to: string = '/apps/') => {
  const navigate = useNavigate()
  const {currentAccountId} = useAccount()
  const prevAccountIdRef = useRef<string | undefined>(currentAccountId)

  useEffect(() => {
    const prev = prevAccountIdRef.current
    if (prev !== undefined && currentAccountId !== undefined && prev !== currentAccountId) {
      navigate(to)
    }
    prevAccountIdRef.current = currentAccountId
  }, [currentAccountId, navigate, to])
}
